export const partial = (fn, ...args) => fn.bind(null, ...args);

const _pipe = (f, g) => (...args) => g(f(...args))

export const pipe = (...fns) => fns.reduce(_pipe)

export const adjustDate = (hour, minute)=>{
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    return date;
};

export const adjustTime = (date, time)=>{
    const d = new Date(date.getTime());
    d.setHours(time.getHours());
    d.setMinutes(time.getMinutes());
    return d;
};

export const authRedirect = (ownProps) => (error) => {
    if (error.response.status === 401) {
        ownProps.history.push(`/login`)
    } else {
        ownProps.history.push(`/error`)
    }
}


// WEBPACK FOOTER //
// ./src/lib/utils.js